// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Switch Component */
.ids-switch {
  color: var(--ids-switch-label-color-text-default);
  margin-block-end: var(--ids-space-sm);
}
.ids-switch.no-margins {
  margin-block-end: var(--ids-space-none);
}
.ids-switch label {
  cursor: pointer;
  user-select: none;
  padding-inline-start: calc(var(--ids-space-xl) + var(--ids-space-xs));
  position: relative;
  display: inline-flex;
  align-items: center;
}
.ids-switch input[type=checkbox] {
  opacity: 0;
  width: 0;
  height: 0;
}
.ids-switch input[type=checkbox] ~ .slider {
  width: var(--ids-space-xl);
  height: var(--ids-space-md);
  position: absolute;
  inset-inline-start: 0;
  background-color: var(--ids-switch-pole-color-background-default);
  border-radius: var(--ids-border-radius-circle);
  border: 1px solid var(--ids-switch-pole-color-border-default);
  box-sizing: border-box;
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-switch input[type=checkbox] ~ .slider::after {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  inset-inline-start: 1px;
  top: 1px;
  background-color: var(--ids-switch-toggle-color-background-default);
  border-radius: var(--ids-border-radius-circle);
  box-shadow: 0 0 2px 0 var(--ids-color-neutral-40);
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-switch input[type=checkbox]:focus ~ .slider {
  box-shadow: var(--ids-switch-shadow-focus);
}
.ids-switch input[type=checkbox]:checked ~ .slider {
  border-color: var(--ids-color-action-default);
  background-color: var(--ids-color-action-default);
}
.ids-switch input[type=checkbox]:checked ~ .slider::after {
  inset-inline-start: 17px;
}
.ids-switch.compact input[type=checkbox]:checked ~ .slider::after {
  inset-inline-start: 15px;
}
.ids-switch.compact label {
  padding-inline-start: calc(34px + var(--ids-space-xs));
}
.ids-switch.compact input[type=checkbox] ~ .slider {
  width: 34px;
  height: 20px;
}
.ids-switch.compact input[type=checkbox] ~ .slider::after {
  width: var(--ids-space-sm);
  height: var(--ids-space-sm);
}
.ids-switch.disabled {
  opacity: var(--ids-switch-disabled-opacity);
}
.ids-switch.disabled label {
  cursor: default;
}

:host([label-position=start]) .ids-switch label {
  padding-inline-start: 0;
}
:host([label-position=start]) .ids-switch:not(.compact) label {
  padding-inline-end: calc(var(--ids-space-xl) + var(--ids-space-xs) + 7px);
}
:host([label-position=start]) .ids-switch.compact label {
  padding-inline-end: calc(34px + var(--ids-space-xs) + 7px);
}
:host([label-position=start]) .ids-switch input[type=checkbox] {
  margin: 0;
}
:host([label-position=start]) .ids-switch input[type=checkbox] ~ .slider {
  inset-inline-start: unset;
  inset-inline-end: 0;
}

:host([size]), :host([size]) .ids-switch, :host([size]) label {
  width: 100%;
  box-sizing: border-box;
}

:host([size=xs]) label {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) label {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) label {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) label {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) label {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) label {
  max-width: var(--ids-input-width-full);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-switch/ids-switch.scss"],"names":[],"mappings":"AAAA,yBAAA;AAUA;EACE,iDAAA;EACA,qCAAA;AARF;AAUE;EACE,uCAAA;AARJ;AAYE;EACE,eAAA;EACA,iBAAA;EACA,qEAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAXJ;AAaI;EACE,0BAhCS;EAiCT,2BAhCU;EAiCV,kBAAA;EACA,qBAAA;EACA,iEAAA;EACA,8CAAA;EACA,6DAAA;EACA,sBAAA;EACA,iEAAA;AAXN;AAaM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,mEAAA;EACA,8CAAA;EACA,iDAAA;EACA,iEAAA;AAXR;AAgBM;EACE,0CAAA;AAdR;AAqBI;EACE,6CAAA;EACA,iDAAA;AAnBN;AAqBM;EACE,wBAAA;AAnBR;AAyBI;EACE,wBAAA;AAvBN;AA6BI;EACE,sDAAA;AA3BN;AA+BM;EACE,WAtFe;EAuFf,YAxFgB;AA2DxB;AA+BQ;EACE,0BAAA;EACA,2BAAA;AA7BV;AAoCE;EACE,2CAAA;AAlCJ;AAoCI;EACE,eAAA;AAlCN;;AA2CI;EACE,uBAAA;AAxCN;AA4CM;EACE,yEAAA;AA1CR;AA+CM;EACE,0DAAA;AA7CR;AAiDI;EACE,SAAA;AA/CN;AAiDM;EACE,yBAAA;EACA,mBAAA;AA/CR;;AAuDE;EACE,WAAA;EACA,sBAAA;AApDJ;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,oCAAA;AArDF;;AAwDA;EACE,sCAAA;AArDF","sourcesContent":["/* Ids Switch Component */\n\n$slider-width: var(--ids-space-xl);\n$slider-height: var(--ids-space-md);\n$slider-compact-height: 20px;\n$slider-compact-width: 34px;\n\n// hidden input margin from label position end\n$slider-start-extra-padding: 7px;\n\n.ids-switch {\n  color: var(--ids-switch-label-color-text-default);\n  margin-block-end: var(--ids-space-sm);\n\n  &.no-margins {\n    margin-block-end: var(--ids-space-none);\n  }\n\n  // SWITCH DEFAULT STATE\n  label {\n    cursor: pointer;\n    user-select: none;\n    padding-inline-start: calc($slider-width + var(--ids-space-xs));\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  input[type='checkbox'] {\n    opacity: 0;\n    width: 0;\n    height: 0;\n\n    ~ .slider {\n      width: $slider-width;\n      height: $slider-height;\n      position: absolute;\n      inset-inline-start: 0;\n      background-color: var(--ids-switch-pole-color-background-default);\n      border-radius: var(--ids-border-radius-circle);\n      border: 1px solid var(--ids-switch-pole-color-border-default);\n      box-sizing: border-box;\n      transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n\n      &::after {\n        content: '';\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        inset-inline-start: 1px;\n        top: 1px;\n        background-color: var(--ids-switch-toggle-color-background-default);\n        border-radius: var(--ids-border-radius-circle);\n        box-shadow: 0 0 2px 0 var(--ids-color-neutral-40);\n        transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n      }\n    }\n\n    &:focus {\n      ~ .slider {\n        box-shadow: var(--ids-switch-shadow-focus);\n      }\n    }\n  }\n\n  // SWITCH ON STATE\n  input[type='checkbox']:checked {\n    ~ .slider {\n      border-color: var(--ids-color-action-default);\n      background-color: var(--ids-color-action-default);\n\n      &::after {\n        inset-inline-start: 17px;\n      }\n    }\n  }\n\n  &.compact input[type='checkbox']:checked {\n    ~ .slider::after {\n      inset-inline-start: 15px;\n    }\n  }\n\n  // SWITCH COMPACT STATE\n  &.compact {\n    label {\n      padding-inline-start: calc($slider-compact-width + var(--ids-space-xs));\n    }\n\n    input[type='checkbox'] {\n      ~ .slider {\n        width: $slider-compact-width;\n        height: $slider-compact-height;\n\n        &::after {\n          width: var(--ids-space-sm);\n          height: var(--ids-space-sm);\n        }\n      }\n    }\n  }\n\n  // SWITCH DISABLED STATE\n  &.disabled {\n    opacity: var( --ids-switch-disabled-opacity);\n\n    label {\n      cursor: default;\n    }\n  }\n}\n\n\n// label position start\n:host([label-position='start']) {\n  .ids-switch {\n    label {\n      padding-inline-start: 0;\n    }\n\n    &:not(.compact) {\n      label {\n        padding-inline-end: calc($slider-width + var(--ids-space-xs) + $slider-start-extra-padding);\n      }\n    }\n\n    &.compact {\n      label {\n        padding-inline-end: calc($slider-compact-width + var(--ids-space-xs) + $slider-start-extra-padding);\n      }\n    }\n\n    input[type='checkbox'] {\n      margin: 0;\n\n      ~ .slider {\n        inset-inline-start: unset;\n        inset-inline-end: 0;\n      }\n    }\n  }\n}\n\n// sizes\n:host([size]) {\n  &, .ids-switch, label {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n:host([size='xs']) label {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) label {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) label {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) label {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) label {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) label {\n  max-width: var(--ids-input-width-full);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
